import { PageContext } from 'context/PageContext';
import { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { loadCustomerProducts, setCustomerProducts } from 'store/slices/customerProductsSlice';
import { loadCustomer, setCustomer } from 'store/slices/customerSlice';
import { getCustomerConceptDiscount } from '../services/CustomerConceptService';
import { mapCustomerData, setCustomerConcept } from '../services/CustomerService';
import { useFormSubmit } from './useFormSubmit';

export const useFetchCustomer = () => {
	const dispatch = useAppDispatch();
	const customer = useAppSelector((state) => state.customer);
	const customerProducts = useAppSelector((state) => state.customerProducts);
	const pageContext = useContext(PageContext);
	const { onSubmit } = useFormSubmit();

	useEffect(() => {
		const call = async () => {
			if (!customer.isDataFetched && !customer.loading) {
				const authResult = await dispatch(loadCustomer(pageContext.metaArea));
				if (authResult.meta.requestStatus === 'fulfilled') {
					dispatch(setCustomer(authResult.payload));
					await mapCustomerData(onSubmit);

					await getCustomerProducts(dispatch, pageContext, customerProducts);
				}
			}
		};
		call();
	}, [customer.isDataFetched]);

	useEffect(() => {
		const call = async () => {
			if (customerProducts.uniqueProducts) {
				const customerConceptDiscount = getCustomerConceptDiscount();
				await setCustomerConcept(customerConceptDiscount, onSubmit);
			}
		};
		call();
	}, [customerProducts.uniqueProducts]);
};

const getCustomerProducts = async (dispatch, pageContext, customerProducts) => {
	if (!customerProducts.isProductDataFetched && !customerProducts.loading) {
		const authResult = await dispatch(loadCustomerProducts(pageContext.metaArea));
		if (authResult.meta.requestStatus === 'fulfilled') {
			dispatch(setCustomerProducts(authResult.payload));
		}
	}
};
